/**
 * L2-P2: moved to @miq/platform (services/lookup-ref.service.ts). This shim keeps the old import
 * path working; new code should import from '@miq/platform'.
 */
export type { ColumnsQueryParams, lookupResp } from '@miq/platform';
export { LookupRefService } from '@miq/platform';
